var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"About"},[_c('h1',[_vm._v(_vm._s(_vm.msg)+" Page")])])
}
var staticRenderFns = []

export { render, staticRenderFns }